export const selectPictures = (state) => state.jewellery.pictures;
export const isLoading = (state) => state.jewellery.isLoading;
export const selectOnePicture = (state) => state.jewellery.selectedPicture